import React from 'react'
import { renderToString } from 'react-dom/server'
import AovDisplay from './AovDisplay'
import Favorite from './Favorite'
import MultipleAovSelect from './MultipleAovSelect'
import style from './style'
import injectSheet from 'react-jss'
import reduce from 'ramda/src/reduce'
import isEmpty from 'ramda/src/isEmpty'
import join from 'ramda/src/join'
import pipe from 'ramda/src/pipe'
import tippy from 'tippy.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const minMaxDisplay = ({ min, max }) => {
  if (min && max) return `${min}mm - ${max}mm`
  else if (min) return `${min}mm`
  else return null
}

const focalDisplay = pipe(
  reduce(
    (acc, val) => [...acc, minMaxDisplay(val)],
    []
  ),
  join(', ')
)

const SelectCameraButton = ({ classes, changeCameraModelAction, selectedCamera, aovs }) =>
  <button
    className={classes.selectCameraButton}
    onClick={_ => changeCameraModelAction(selectedCamera, aovs.length === 1 ? aovs[0] : null)}
  >
    <FontAwesomeIcon icon='video' />Select This Camera
  </button>

/* eslint-disable camelcase */
class CameraDetails extends React.Component {

  componentDidMount = _ => {
    tippy('#ndaaTag2', { duration: 0, allowTitleHTML: true, delay: [0, 250], interactive: true, theme: 'topbar', placement: 'bottom' })
  }

  ndaaHelpText = _ => (
    <span>
      Products that are produced by covered companies or have covered components as defined by NDAA FY 2019 Sec 889.
      <a href="https://ipvm.com/reports/ndaa-guide" target="_blank"> Read our guide here</a>
    </span>
  )

  render() {
    const { classes, selectedCamera, changeCameraModelAction, permalink } = this.props
    const { id, image_url, model, manufacturer, ndaa_compliant, resolution_name, form_factor, aovs, imager_count,
    focal_lengths, infrared, super_low_light, show_specification_link, model_path, multi_imager_type } = selectedCamera

    return (
      <div className={classes.CameraDetails}>
        { !permalink && <Favorite id={id} /> }
        { image_url && <img src={image_url} /> }
        <h4>{manufacturer}</h4>
        <h4>{model}</h4>
        <table className={classes.table} cellSpacing='0'>
          { (form_factor || '').toLowerCase() === 'multi-imager'
            ? <tbody>
                <tr><td>Form</td><td>{form_factor}</td></tr>
                <tr><td>Imager Count</td><td>{imager_count}</td></tr>
                <tr><td>Multi-Imager Type</td><td>{multi_imager_type}</td></tr>
                <tr>
                  <td>
                    NDAA Compliant
                    <a title={renderToString(this.ndaaHelpText())} style={{ marginLeft: '2px' }} id='ndaaTag2'>
                      <FontAwesomeIcon icon='question-circle' />
                    </a>
                  </td>
                  <td>
                    {ndaa_compliant ? 'Yes' : 'No'}
                  </td>
                </tr>
              </tbody>
            : <tbody>
                <tr><td>Form</td><td>{form_factor}</td></tr>
                <tr><td>Resolution</td><td>{ resolution_name.match('12MP 270°') ? '12 MP' : resolution_name }</td></tr>
                <tr><td>IR</td><td>{infrared > 0 ? `${infrared}m` : 'None'}</td></tr>
                { super_low_light && <tr><td>Super Low Light</td><td>Yes</td></tr> }
                <tr><td>Focal Length</td><td>{ isEmpty(focal_lengths) ? 'Variable' : focalDisplay(focal_lengths) }</td></tr>
                { aovs.length <= 1 && <AovDisplay {...{ aovs, changeCameraModelAction, selectedCamera }} /> }
                <tr>
                  <td>
                    NDAA Compliant
                    <a title={renderToString(this.ndaaHelpText())} style={{ marginLeft: '2px' }} id='ndaaTag2'>
                      <FontAwesomeIcon icon='question-circle' />
                    </a>
                  </td>
                  <td>
                    {ndaa_compliant ? 'Yes' : 'No'}
                  </td>
                </tr>
              </tbody>
          }
        </table>
        {
          show_specification_link &&
          <a
            style={{ marginBottom: '.5rem', display: 'block' }}
            href={`${IPVM_URL}/camera/${model_path}`}
            target='_blank'
          >
            <FontAwesomeIcon icon='external-link-alt' /> show camera full specification
          </a>
        }
        { aovs.length <= 1
          ? <SelectCameraButton {...{ classes, changeCameraModelAction, selectedCamera, aovs }} />
          : <MultipleAovSelect {...{ aovs, changeCameraModelAction, selectedCamera }} />
        }
      </div>
    )
  }
}

export default injectSheet(style)(CameraDetails)



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/CameraDetailsContainer/CameraDetails/index.js